import $ from 'jquery'
import { CART_UPDATED, CART_LOADING, CART_LOADING_FINISH } from '../events'
import Emitter from './Emitter'

class Cart {
	data = {}
	loading = false

	startLoading() {
		this.loading = true
		Emitter.emit(CART_LOADING)
	}

	finishLoading() {
		this.loading = false
		Emitter.emit(CART_LOADING_FINISH)
	}

	addItem({ id, quantity = 1, properties }) {
		this.startLoading()
		return new Promise((resolve, reject) => {
			$.ajax({
				method: 'POST',
				url: '/cart/add.js',
				data: {
					id: id,
					quantity: quantity,
					properties: { ...properties }
				},
				dataType: 'json',
				success: data => {
					resolve(data)
					this.get()
				},
				error: data => {
					this.finishLoading()
					reject(data)
				}
			})
		})
	}

	get() {
		this.startLoading()
		return new Promise((resolve, reject) => {
			$.ajax({
				method: 'GET',
				url: '/cart.js',
				dataType: 'json',
				success: data => {
					this.finishLoading()
					Emitter.emit(CART_UPDATED, data)
					resolve(data)
					this.cart = data
				},
				error: data => {
					this.finishLoading()
					reject(data)
				}
			})
		})
	}

	changeQuantity(id, quantity) {
		this.startLoading()
		return new Promise((resolve, reject) => {
			$.ajax({
				method: 'POST',
				url: '/cart/change.js',
				dataType: 'json',
				data: {
					id: id,
					quantity: quantity
				},
				success: data => {
					resolve(data)
					// fix recharge cookie bug
					this.get().then(data => {
						if (!data.item_count) this.clear()
					})
				},
				error: data => {
					this.finishLoading()
					reject(data)
				}
			})
		})
	}

	clear() {
		return new Promise((resolve, reject) => {
			$.ajax({
				method: 'POST',
				url: '/cart/clear.js',
				dataType: 'json',
				success: data => {},
				error: data => {}
			})
		})
	}

	checkout() {
		return new Promise((resolve, reject) => {
			let paramCart = '&cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)') || 0)[2]
			$.ajax({
				type: 'GET',
				url: '/cart.js',
				dataType: 'text',
				success: function(data) {
					if (data.indexOf('subscription_id') > -1) {
						var paramDomain = 'myshopify_domain=' + window.shopifyDomain
						var paramLinker
						try {
							paramLinker = '&' + ga.getAll()[0].get('linkerParam')
						} catch (err) {
							paramLinker = ''
						}
						var paramCustomer = window.customerParam
						window.location =
							'https://checkout.rechargeapps.com/r/checkout?' +
							paramDomain +
							paramCart +
							paramLinker +
							paramCustomer
					} else {
						window.location = '/checkout'
					}
					resolve()
				}
			})
		})
	}
}

const c = new Cart()
export default c
